import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const NatureOfSoftwareModule = () => (
  <QPhototModuleSubtopic
    title="Nature of Software, SE Basics, Process & Projects"
    videos={[
      "https://www.youtube.com/embed/qxv6vPlx2Cs",
      "https://www.youtube.com/embed/PfRDU5u6A9Y"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "Compare the failure curves provided below for hardware, civil, electrical, and software projects. Highlight their unique characteristics and typical failure rates over their lifecycle stages. Discuss the factors influencing failures and mitigation strategies for each project type.",
        

        
      },
      {image:"/se_1.png"},
      {image:"/se_2.png"},
      {
        text: "Explain the Umbrella Activities that are carried out in the development of a software project."
      }
    ]}
    exampleVideos={[]}
  />
);

export default NatureOfSoftwareModule;
